import React from 'react';
import { TextField, InputAdornment, Grid, makeStyles } from '@material-ui/core';
import StopIcon from '@material-ui/icons/Stop';
import { get } from 'lodash';
import styles from './styles';

export interface Props {
  errors?: any;
  label: string;
  stateKey: string;
  value: string;
  setFieldValue?: (field: string, value: any) => void;
}

const TextFieldColor = ({
  errors,
  label,
  stateKey,
  value,
  setFieldValue,
}: Props) => {
  const useStyles = makeStyles(styles(value));
  const classes = useStyles();

  return (
    <Grid item xs={5} data-testid={'autosky-textfieldcolor'}>
      <TextField
        className={classes.textContainer}
        value={value}
        variant="outlined"
        label={label}
        error={!!get(errors, stateKey, null)}
        helperText={get(errors, stateKey, null)}
        onChange={e => {
          if (setFieldValue) setFieldValue(stateKey, e.target.value || '');
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <StopIcon className={classes.icon} fontSize="large" />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
};

export default TextFieldColor;
